import * as types from './types'
export default {
  [types.SET_YEARS](state, data) {
    let _data = []
    for (let datum of data) {
      _data.push({
        name: datum.year,
        value: datum.year
      })
    }
    state.years = JSON.parse(JSON.stringify(Object.assign(state.years, _data)))
  },
  [types.SET_QUEUE](state, data) {
    let _data = []
    for (let datum of data) {
      _data.push({
        name: datum.queueName,
        value: datum.id
      })
    }
    state.queue = JSON.parse(JSON.stringify(Object.assign(state.queue, _data)))
  },
  [types.SET_MAKES](state, data) {
    let _data = []
    for (let datum of data) {
      _data.push({
        name: datum.name,
        value: datum.makeId
      })
    }
    state.makes = JSON.parse(JSON.stringify(Object.assign(state.makes, _data)))
  },
  [types.SET_LANGUAGES](state, data) {
    let _data = []
    for (let datum of data) {
      _data.push({
        name: datum.language,
        value: datum.languageId
      })
    }
    state.languages = JSON.parse(JSON.stringify(Object.assign(state.languages, _data)))
  },
  [types.SET_ANSWER](state, data) {
    state.status = data.error
    state.answer = data.decision
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/dispatch/mutations.js